import { HTTP_MMC, HTTP_ALB } from "../axios";

// 上传接口
export const uploadFile = (params) => {
  return HTTP_MMC.post("/upload/upload/uploadfile", params);
};


// 直播间上传接口 
export const uploadRecord = (params) => {
  return HTTP_ALB.post("/live/live/record", params);
}